import { PLACEMENT as e } from "../../values/Placement.js";
import t from "./Tooltip.js";
import { TRIGGER as n } from "../../values/Trigger.js";
import r from "../overlay/OverlayTrigger.js";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/tooltip/SimpleTooltip.tsx
var a = (n) => {
	let { children: a, placement: o = e.BOTTOM, trigger: s, content: c, delay: l, targetRef: u, ...d } = n;
	return /* @__PURE__ */ i(r, {
		placement: o,
		trigger: s,
		overlay: /* @__PURE__ */ i(t, {
			...d,
			ref: u,
			children: c
		}),
		delay: l,
		children: a
	});
};
a.TRIGGER_CLICK = n.CLICK, a.TRIGGER_HOVER = n.HOVER, a.TRIGGER_FOCUS = n.FOCUS;
//#endregion
export { a as default };

//# sourceMappingURL=SimpleTooltip.js.map